import { useEffect } from 'react';
import '../styles/ContactUs.scss';
import ContactUsForm from './ContactUsForm';

function ContactUs(props: { title: string }) {
  useEffect(() => {
    document.title = props.title;
  });
  return (
    <div className="contact-us-page">
      <p className="contact-us-desc first">LET'S WORK</p>
      <p className="contact-us-desc second">TOGETHER</p>
      <ContactUsForm />
    </div>
  );
}

export default ContactUs;
